<script>
import appConfig from '@src/app.config'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>

<template>
  <div id="app-content">
    <v-app>
      <v-toolbar app flat color="white" height="100px" margin-left="20px">
        <img class="DD-site-header" src="@src/core/assets/images/DD_Site_Header.jpg" alt="Data Dive Logo Header">
        <img class="betaCorner" src="@src/core/assets/images/betaCorner_DD_v3.svg" alt="Beta Version Logo">
      </v-toolbar>
      <v-content class="top-line">
        <v-container fluid>
          <router-view :key="$route.fullPath"/>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>


<!-- This should generally be the only global CSS in the app. -->

<style lang="stylus">
@import '~vuetify/src/stylus/main';
@import './core/assets/stylus/main';
@import url('https://fonts.googleapis.com/css?family=Roboto');
</style>

<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';

*,
*::before,
*::after {
  box-sizing: border-box;
}
* {
  text-transform: none !important;
}

body {
  background: $color-body-bg;
}

#app {
  //@extend %typography-small;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}

h1 {
  //@extend %typography-xxlarge;
  font-family: MontserratExtraBold, Verdana;
}

h2 {
  //@extend %typography-xlarge;
  font-family: MontserratBold, Verdana;
}

h3 {
  //@extend %typography-large;
  font-family: MontserratMedium, Verdana;
}

h4 {
  //@extend %typography-medium;
  font-family: MontserratRegular, Verdana;
}

h5,
h6 {
  @extend %typography-small;
}

// ===
// Vendor
// ===

#nprogress .bar {
  background: $color-link-text;
}

@font-face {
  font-family: MontserratBold;
  src: url('./core/assets/fonts/Montserrat/Montserrat-Bold.ttf');
}

@font-face {
  font-family: MontserratExtraBold;
  src: url('./core/assets/fonts/Montserrat/Montserrat-ExtraBold.ttf');
}

@font-face {
  font-family: MontserratMedium;
  src: url('./core/assets/fonts/Montserrat/Montserrat-Medium.ttf');
}

@font-face {
  font-family: MontserratRegular;
  src: url('./core/assets/fonts/Montserrat/Montserrat-Regular.ttf');
}

@font-face {
  font-family: OpenSansBold;
  src: url('./core/assets/fonts/OpenSans/OpenSans-Bold.ttf');
}

@font-face {
  font-family: OpenSansLight;
  src: url('./core/assets/fonts/OpenSans/OpenSans-Light.ttf');
}

@font-face {
  font-family: OpenSansRegular;
  src: url('./core/assets/fonts/OpenSans/OpenSans-Regular.ttf');
}

body {
  font-family: OpenSansRegular, Arial;
  color: #707070;
  font-size: 12px;
  font-size: 1rem;
}

#app {
  flex-direction: column;
}

.container {
  padding: 0;
}

.fluid {
  height: 100%;
  overflow: hidden;
}

.application.theme--light {
  font-family: OpenSansRegular, Arial;
  font-size: 12px;
  font-size: 1rem;
  color: #707070;
  text-decoration-color: #707070;
  background-color: rgba(255, 255, 255, 1);
}

.top-line {
  border-top: 1px solid #e6e6e6;
}

.theme--light .card,
.application .theme--light.card,
.theme--light .list .list__tile:not(.list__tile--active),
.application .theme--light.list .list__tile:not(.list__tile--active) {
  color: #707070;
}
.btn__content {
  font-size: 16px;
  font-size: 1.25rem;
  font-weight: bold;
  color: white;
}
.input-group.input-group--selection-controls
  .input-group__input
  .icon--selection-control {
  height: 24px;
}
.logo-header {
  width: 274px;
  height: 36px;
}

.input-group.input-group--dirty.checkbox.input-group--selection-controls.input-group--active.accent--text {
  color: #0892c5 !important;
}
.DD-site-header {
  height: 56px;
}

.betaCorner {
  float: right;
  position: absolute;
  top: 0;
  right: -17px;
  width: 100px;
}
</style>
